import CalendarTheme from "css/themes/calendar/calendar.css";
import moment from "moment-timezone";
import React from "react";

const MonthHeader = ({ day }) => (
  <div className={CalendarTheme.calendarHeader}>
    <span>{moment(day).format("ddd")}</span>
  </div>
);

export default MonthHeader;
